<template>
    <section>
        <div class="row">
            <div class="col-md-4 pt-2">
                <div class="mb-3" style="width: 100%; padding: 5px; border:1px solid">
                    <vue-element-loading :active="loading.summary" spinner="bar-fade-scale" color="#FF6700"/>
                    <table style="width: 100%;">
                        <tr>
                            <th colspan="3"> Revenue Summary</th>
                        </tr>
                        <tr>
                            <td style="width: 10%">&nbsp;</td>
                            <th>Projected:</th>
                            <td class="text-danger">{{ summary.projected | dollar }}</td>
                        </tr>
                        <tr>
                            <td style="width: 10%">&nbsp;</td>
                            <th>Completed:</th>
                            <td class="text-danger">{{ summary.completed | dollar }}</td>
                        </tr>
                        <tr>
                            <td style="width: 10%">&nbsp;</td>
                            <th>Billed:</th>
                            <td class="text-danger">{{ summary.billed | dollar }}</td>
                        </tr>
                    </table>
                </div>
                <b>Invoice Register</b>
                <br>
                <div style="margin:7px 4px;">
                    <input v-model="period.start" type="date">
                    to
                    <input type="date" v-model="period.end">
                </div>
                <div style="margin:0px;">
                    <input type="radio" id="summary_type1" name="summary_type" v-model="filters.summary_type" value="1">
                    Summary
                    <input type="radio" checked id="summary_type2" name="summary_type" v-model="filters.summary_type"
                           value="2"> Detailed
                    <input type="radio" id="summary_type3" name="summary_type" v-model="filters.summary_type" value="3">
                    Sales Tax<br>
                    <input type="radio" id="summary_type6" name="summary_type" v-model="filters.summary_type" value="6">
                    Category
                    <select name="summary_type_select" class="form-control" style="margin-left: 8px;"
                            v-model="filters.summary_type_select">
                        <option value="">Select...</option>
                        <option value="7">Elite</option>
                        <option value="8">UFPLI</option>
                        <option value="5">Metro</option>
                        <option value="4">Hours</option>
                    </select>
                </div>
                <div style="margin:6px 4px;">
                    <b>Search By: </b><br>
                    <div class="row b-filter" style="margin-left: 15px;">
                        <div class="col-md-12 d-flex">
                            <label>Salesperson</label>
                            <span>&nbsp;</span>
                            <select-data-component
                                ref="salesperson"
                                :initial-value="null" :name="`acc-${Math.random()}`"
                                @selected="(val) => {filters.salesperson = val;}"
                                table="users" field-id="id"
                                field-name="CONCAT(name, ' ', last_name)">
                            </select-data-component>
                        </div>
                        <div class="col-md-12 d-flex">
                            <label>Billing Acct#</label>
                            <span>&nbsp;</span>
                            <select-data-component
                                ref="billing_account"
                                :initial-value="null" :name="`acc-${Math.random()}`"
                                @selected="(val) => {filters.billing_account = val;}"
                                table="billing_accounts" field-id="id"
                                field-name="account_number">
                            </select-data-component>
                        </div>
                        <div class="col-md-12 d-flex">
                            <label>WT#</label>
                            <span>&nbsp;</span>
                            <input class="form-control" v-model="filters.ticket">
                        </div>
                        <div class="col-md-12 d-flex">
                            <label>Invoice# </label>
                            <span>&nbsp;</span>
                            <input class="form-control" v-model="filters.inv_id">
                        </div>
                    </div>
                </div>
                <div class="text-left factions mt-2 mb-2">
                    <span class="fa fa-file text-danger"></span>
                    <button class="btn  btn-primary" @click="submit_invoice_request('invoice')" type="button">Submit
                    </button>
                    <button class="btn btn-warning" @click.prevent.stop="clearMonth" type="reset">Clear</button>
                </div>
            </div>
            <div class="col-md-7  ml-3 ">
                <div class="row pt-2 pb-2" style="border: 1px solid">
                    <div class="col-md-9">
                        <table>
                            <tr>
                                <th style="width: 40%"> Year:
                                    <select class="form-control" name="current_year" v-model="current_year">
                                        <option :value="n" v-for="n in years">{{ n }}</option>
                                    </select>
                                </th>
                                <th style="width: 30%"></th>
                                <th style="width: 30%">Billed/Unbilled</th>
                            </tr>
                            <tr>
                                <th>
                                    <span class="d-block"
                                          @click="templates.rsm_template_show = !templates.rsm_template_show">Remote Station Monitoring</span>
                                    <a target="_blank" v-if="templates.rsm_template_show"
                                       href="/billings/invoice-templates?sid=67">Edit Invoice Template</a>
                                </th>
                                <td>
                                    <billing-month ref="rsm_month" @selected="setMonth"></billing-month>
                                </td>
                                <td>
                                    <span>Other</span>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <span class="d-block"
                                          @click="templates.em_template_show = !templates.em_template_show">Elevator Monitoring</span>
                                    <a target="_blank" v-if="templates.em_template_show"
                                       href="/billings/invoice-templates?sid=84">Edit Invoice Template</a>
                                </th>
                                <td>
                                    <billing-month ref="em_month" @selected="setMonth"></billing-month>
                                </td>
                                <td><span>Other</span></td>
                            </tr>
                            <tr>
                                <th>
                                    <span class="d-block"
                                          @click="templates.i_template_show = !templates.i_template_show">Inspections</span>
                                    <a target="_blank" v-if="templates.i_template_show"
                                       href="/billings/invoice-templates?sid=0">Edit Invoice Template</a>
                                </th>
                                <td>
                                    <billing-month ref="i_month" @selected="setMonth"></billing-month>
                                </td>
                                <td><span>Other</span></td>
                            </tr>
                            <tr>
                                <th>
                                    <span class="d-block"
                                          @click="templates.sr_template_show = !templates.sr_template_show">Service & Repair</span>
                                    <a target="_blank" v-if="templates.sr_template_show"
                                       href="/billings/invoice-templates?sid=-1">Edit Invoice Template</a>

                                </th>
                                <td>
                                    <billing-month ref="sr_month" @selected="setMonth"></billing-month>
                                </td>
                                <td><span>Other</span></td>
                            </tr>
                            <tr>
                                <th>
                                    <span class="d-block"
                                          @click="templates.bc_template_show = !templates.bc_template_show">Billing Cycle</span>
                                    <a target="_blank" v-if="templates.bc_template_show"
                                       href="/billings/invoice-templates?sid=-2">Edit Invoice Template</a>

                                </th>
                                <td>
                                    <billing-month ref="bc_month" @selected="setMonth"></billing-month>
                                </td>
                                <td><span>Other</span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-3" style="border-left: 1px solid">
                        <table class="ready_invoice">
                            <tr>
                                <th>
                                    <div style="padding-top: 15px; padding-bottom: 10px">Ready to Invoice</div>
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    <billing-month ref="rsm_ri_month" @selected="setMonth"></billing-month>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <billing-month ref="em_ri_month" @selected="setMonth"></billing-month>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <billing-month ref="i_ri_month" @selected="setMonth"></billing-month>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <billing-month ref="sr_ri_month" @selected="setMonth"></billing-month>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <billing-month ref="bc_ri_month" @selected="setMonth"></billing-month>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-12" style="text-align: center">
                        <button @click="submit_invoice_request('billing')" class="btn  btn-primary" type="button">
                            Submit
                        </button>
                        <button @click="clearMonth()" class="btn btn-warning" type="reset">Clear</button>
                    </div>
                </div>

            </div>
        </div>
        <div class="signer_invoice" v-if="isSelected">
            <a @click.prevent.stop="assignInvoice()" href="#">Assign<br>
            Invoice
            </a>
        </div>
        <div class="col-md-12" style="padding: 10px;">
            <vue-element-loading text="Please wait a second. Data updating..." :active="loading.invoice"
                                 spinner="bar-fade-scale" color="#FF6700"/>
        </div>
        <div class="invoices">
            <strong v-if="recordsCount">{{ 'Number of records found:' + recordsCount }}</strong>
            <div class="table-wrapper">

                <div class="modal" :class="{'show':modal.customer_purchase_order}" id="pos" tabindex="-1" role="dialog"
                     aria-labelledby="exampleModalLabel" aria-hidden="false"
                     :style="{display: modal.customer_purchase_order ? 'block' : 'none'}">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Customer Purchase Orders</h5>
                                <button type="button" class="close" @click="modal.customer_purchase_order = false;"
                                        data-dismiss="modal"
                                        aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" style="max-height: 400px; overflow-y: scroll;">
                                <customer-purchase-order-select @updatePo="submit_invoice_request"
                                                                ref="customer-purchase-order"
                                                                :site-id="this.siteId"
                                                                :service-ticket-number='this.serviceTicket'>
                                </customer-purchase-order-select>
                            </div>
                            <div class="modal-footer">
                                <button type="button" @click="modal.customer_purchase_order = false;"
                                        class="btn btn-secondary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <slot v-if="recordsCount && type === 'bill'">
                    <p><strong>Billed</strong></p>
                </slot>
                <slot v-if="recordsCount && type === 'record'">
                    <p><strong>Ready to Invoice</strong></p>
                </slot>
                <table v-if="recordsCount && filters.summary_type !== '1'" class="table-invoice " cellspacing="12"
                       style="width: 100%">
                    <thead>
                    <tr>
                        <th>Invoice</th>
                        <th>Billing Acc#</th>
                        <th>Svc Tix#</th>
                        <th>Site Acc#</th>
                        <th>Purchase Orders</th>
                        <th>Billing Name</th>
                        <th>Care of</th>
                        <th>Billing Address</th>
                        <th>Job Site</th>
                        <th>System Type</th>
                        <th>Protected Area</th>
                        <th>Description</th>
                        <th>Charges</th>
                        <th>Sales Tax</th>
                        <th>Total Due</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(invoice, invoiceIndex) in invoices" :data-ticket-id="invoice.service_ticket"
                        :data-bill-account="invoice.billing_account_number" :data-site-id="invoice.site_id">
                        <slot v-if="invoice.inv_id">
                            <td class="invoice_td_id">
                                <a title="Open Invoice" href="" @click.prevent.stop="openInvoice(invoice.inv_id)">
                                    <strong>{{ invoice.inv_id > 0 ?  invoice.inv_id  : 'CR' + abs(invoice.inv_id)  }}</strong>
                                </a>
                                <a href="" @click.prevent.stop="removeInvoice(invoice.inv_id)">x</a>
                                <span v-if="invoice.credit" class="text-danger">C</span>
                                <span v-if="invoice.emailed" class="text-danger">E</span>
                                <a target="_blank" :href="`/billings/invoice/${invoice.inv_id}/pdf`"
                                   v-if="invoice.printed" class="text-danger">P</a>
                                <span>{{ invoice.created_at | dateUs }}</span>
                            </td>
                        </slot>
                        <slot v-else>
                            <td  class="invoice_td" style="padding-left: 10px;">
                                <slot v-if="isSelected && (invoice.site_id===siteId)">
                                    <input type="checkbox" :value="invoice.row_id" v-model="selecteds">
                                </slot>
                                <slot v-else>
                                    <a title="Invoice by Billing #" href=""
                                       @click.prevent.stop="inv_bill(invoice.billing_account_number, invoice.site_id, invoice.sifid)">B</a>
                                    <a title="Invoice by Work Ticket #" href=""
                                       @click.prevent.stop="inv_svc(invoice.service_ticket,invoice.site_id, invoice.sifid, invoiceIndex)">T</a>
                                    <a title="Invoice by Site #" href=""
                                       @click.prevent.stop="sel_bill(invoice.site_id, invoice.sifid)">S</a>
                                </slot>
                            </td>
                        </slot>
                        <td>{{ invoice.billing_account_number }}</td>
                        <td>
                            <span class="indexInvoice" style="display: none">{{ invoiceIndex }}</span>
                            <span class="service_ticket_number">{{ invoice.service_ticket }}</span>
                            <div v-if="submitType==='billing'" v-html="invoice.timesheet_code"></div>
                            <div v-else>
                                <a target="_blank" :href="`/work_orders/${invoice.timesheet_id}/edit`"
                                   class="text-success">C</a>
                                <a target="_blank" :href="`/work_orders/${invoice.timesheet_id}/edit`"
                                   v-if="invoice.approved" class="text-success">A</a>
                                <a target="_blank" :href="`/work_orders/${invoice.timesheet_id}/edit`"
                                   v-if="invoice.follow_up_required" class="text-danger">FU</a>
                            </div>
                        </td>
                        <td>{{ invoice.site_acc_number }}</td>
                        <td>
                            <a v-if="invoice.po_real && invoice.po_real.length" href=""
                               @click.prevent.stop="openModalPurchaseOrder(invoice.service_ticket, invoice.site_id,)">{{
                                    invoice.po_real
                                }}</a>
                            <a href=""
                               @click.prevent.stop="openModalPurchaseOrder(invoice.service_ticket, invoice.site_id)"
                               v-else>No PO's
                                Available</a>
                        </td>
                        <td>{{ invoice.client_name }}</td>
                        <td>{{ invoice.care_of_line_1 }}</td>
                        <td :title="cleanHTML(invoice.address2)">
                            {{ truncateAddress(invoice.address2) }}
                        </td>
                        <td>{{ invoice.job_site }}</td>
                        <td>{{ invoice.system_type }}</td>
                        <td>{{ invoice.protectedarea }}</td>
                        <td>{{ invoice.billing_description_text }}</td>
                        <td class="money">{{ invoice.amount | dollar }}</td>
                        <td class="money">{{ invoice.saltaxr_value | dollar }}</td>
                        <td class="money">{{ invoice.total_due | dollar }}</td>
                    </tr>
                    </tbody>
                </table>
                <table v-if="recordsCount && filters.summary_type === '1'" class="table-invoice " cellspacing="12"
                       style="width: 100%">
                    <thead>
                    <tr>
                        <th>Invoice</th>
                        <th>Billing Acc#</th>
                        <th>Svc Tix#</th>
                        <th>Purchase Orders</th>
                        <th>Billing Name</th>
                        <th>Charges</th>
                        <th>Sales Tax</th>
                        <th>Total Due</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(invoice, invoiceIndex) in invoices"  :data-ticket-id="invoice.service_ticket"
                        :data-bill-account="invoice.billing_account_number" :data-site-id="invoice.site_id">
                        <slot v-if="invoice.inv_id">
                            <td class="invoice_td_id">
                                <a title="Open Invoice" href="" @click.prevent.stop="openInvoice(invoice.inv_id)">
                                    <strong>{{ invoice.inv_id }}</strong>
                                </a>
                                <a href="" @click.prevent.stop="removeInvoice(invoice.inv_id)">x</a>
                                <a href="" @click.prevent.stop="createCreditMemo(invoice.inv_id)">C</a>
                                <a v-if="invoice.email_log" :href="'/email_logs/'+invoice.email_log+'/edit'" target="_blank">E</a>
                                <a target="_blank" :href="`/billings/invoice/${invoice.inv_id}/pdf`"
                                   v-if="invoice.printed" class="text-danger">P</a>
                                <span>{{ invoice.created_at | dateUs }}</span>

                            </td>
                        </slot>
                        <slot v-else>
                            <td class="invoice_td">
                                <a title="Invoice by Billing #" href=""
                                   @click.prevent.stop="inv_bill(invoice.billing_account_number, invoice.site_id, invoice.sifid)">B</a>
                                <a title="Invoice by Work Ticket #" href=""
                                   @click.prevent.stop="inv_svc(invoice.service_ticket,invoice.site_id, invoice.sifid, invoiceIndex)">T</a>
                                <a title="Invoice by Site #" href=""
                                   @click.prevent.stop="sel_bill(invoice.site_id, invoice.sifid)">S</a>
                            </td>
                        </slot>
                        <td>{{ invoice.billing_account_number }}</td>
                        <td>
                            <span class="indexInvoice" style="display: none">{{ invoiceIndex }}</span>
                            <span class="service_ticket_number">
                                {{ invoice.service_ticket }}<br>
                                <a target="_blank" :href="`/work_orders/${invoice.timesheet_id}/edit`"
                                   class="text-success">C</a>
                                <a target="_blank" :href="`/work_orders/${invoice.timesheet_id}/edit`"
                                   v-if="invoice.approved" class="text-success">A</a>
                                <a target="_blank" :href="`/work_orders/${invoice.timesheet_id}/edit`"
                                   v-if="invoice.follow_up_required" class="text-danger">FU</a>
                            </span>
                            <div v-html="invoice.timesheet_code"></div>
                        </td>
                        <td>
                            <a v-if="invoice.po_real && invoice.po_real.length" href=""
                               @click.prevent.stop="openModalPurchaseOrder(invoice.service_ticket, invoice.site_id,)">{{
                                    invoice.po_real
                                }}</a>
                            <a href=""
                               @click.prevent.stop="openModalPurchaseOrder(invoice.service_ticket, invoice.site_id)"
                               v-else>No PO's
                                Available</a>
                        </td>
                        <td class="money">{{ invoice.client_name }}</td>
                        <td class="money">{{ invoice.amount | dollar }}</td>
                        <td class="money">{{ invoice.saltaxr_value | dollar }}</td>
                        <td class="money">{{ invoice.total_due | dollar }}</td>
                    </tr>
                    </tbody>
                </table>

                <slot v-if="recordsCount && type === 'bill' && filters.summary_type !== 1">
                    <p><strong>Unbilled</strong></p>
                    <table class="table-invoice " cellspacing="12" style="width: 100%">
                        <thead>
                        <tr>
                            <th>Invoice</th>
                            <th>Billing Acc#</th>
                            <th>Svc Tix#</th>
                            <th>Site Acc#</th>
                            <th>Purchase Orders</th>
                            <th>Billing Name</th>
                            <th>Care of</th>
                            <th>Billing Address</th>
                            <th>Job Site</th>
                            <th>System Type</th>
                            <th>Protected Area</th>
                            <th>Description</th>
                            <th>Charges</th>
                            <th>Sales Tax</th>
                            <th>Total Due</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(invoice, billedIndex) in unbilled"
                            :data-bill-account="invoice.billing_account_number" :data-site-id="invoice.site_id">
                            <slot v-if="invoice.inv_id">
                                <td class="invoice_td_id">
                                    <a title="Open Invoice" href="" @click.prevent.stop="openInvoice(invoice.inv_id)">
                                        <strong>{{ invoice.inv_id }}</strong>
                                    </a>
                                    <a href="" @click.prevent.stop="removeInvoice(invoice.inv_id)">x</a>

                                </td>
                            </slot>
                            <slot v-else>
                                <td class="invoice_td">
                                    <a title="Invoice by Billing #" href=""
                                       @click.prevent.stop="inv_bill(invoice.billing_account_number, invoice.site_id, invoice.sifid)">B</a>
                                    <a title="Invoice by Work Ticket #" href=""
                                       @click.prevent.stop="inv_svc(invoice.service_ticket,invoice.site_id, invoice.sifid, invoiceIndex)">T</a>
                                    <a title="Invoice by Site #" href=""
                                       @click.prevent.stop="sel_bill(invoice.site_id, invoice.sifid)">S</a>
                                </td>
                            </slot>
                            <td>{{ invoice.billing_account_number }}</td>
                            <td>
                                <span class="indexInvoice" style="display: none">{{ invoiceIndex }}</span>
                                <span class="service_ticket_number">{{ invoice.service_ticket }}</span>
                                <div v-html="invoice.timesheet_code"></div>
                            </td>
                            <td>{{ invoice.site_acc_number }}</td>
                            <td>
                                <a v-if="invoice.po_real && invoice.po_real.length" href=""
                                   @click.prevent.stop="openModalPurchaseOrder(invoice.service_ticket, invoice.site_id,)">{{
                                        invoice.po_real
                                    }}</a>
                                <a href=""
                                   @click.prevent.stop="openModalPurchaseOrder(invoice.service_ticket, invoice.site_id)"
                                   v-else>No PO's
                                    Available</a>
                            </td>
                            <td>{{ invoice.client_name }}</td>
                            <td>{{ invoice.care_of_line_1 }}</td>
                            <td :title="cleanHTML(invoice.address2)">
                                {{ truncateAddress(invoice.address2) }}
                            </td>
                            <td>{{ invoice.job_site }}</td>
                            <td>{{ invoice.system_type }}</td>
                            <td>{{ invoice.protectedarea }}</td>
                            <td>{{ invoice.billing_description_text }}</td>
                            <td>{{ invoice.amount | dollar }}</td>
                            <td>{{ invoice.saltaxr_value | dollar }}</td>
                            <td>{{ invoice.total_due | dollar }}</td>
                        </tr>
                        </tbody>
                    </table>
                </slot>
                <p v-if="recordsCount  === 0 && loaded && !loading.invoice"><strong>No record found </strong></p>
            </div>
            <strong v-if="recordsCount">{{ 'Number of records found:' + recordsCount }}</strong>
        </div>
    </section>
</template>

<script>

import BillingMonth from "./BillingMonth.vue";
import VueElementLoading from 'vue-element-loading'
import CustomerPurchaseOrderSelect from "../sites/CustomerPurchaseOrderSelect.vue";

export default {
    name: "Billings",
    components: {CustomerPurchaseOrderSelect, VueElementLoading, BillingMonth},
    props: {},
    data() {
        return {
            loaded: false,
            month_components: [
                "rsm_month",
                "em_month",
                "i_month",
                "sr_month",
                "bc_month",
                "rsm_ri_month",
                "em_ri_month",
                "i_ri_month",
                "sr_ri_month",
                "bc_ri_month",
            ],
            current_year: null,
            years: [],
            templates: {
                rsm_template_show: false,
                em_template_show: false,
                i_template_show: false,
                sr_template_show: false,
                bc_template_show: false,
            },
            summary: {
                projected: 0,
                completed: 0,
                billed: 0,
            },
            filters: {
                summary_type: 2,
                summary_type_select: ''
            },
            period: {
                start: null,
                end: null,
            },
            loading: {
                summary: false,
                invoice: false,
            },
            invoices: [],
            unbilled: [],
            bill_month: null,
            bill_other: null,
            report_month: null,
            sid: 0,
            type: 'report',
            modal: {
                customer_purchase_order: false
            },
            serviceTicket: null,
            siteId: null,
            submitType: '',
            isSelected: false,
            siteSelected: '',
            selecteds: [],
        }
    },
    computed: {
        recordsCount() {
            if (this.type === 'bill') {
                return this.invoices.length + this.unbilled.length;
            }
            return this.invoices.length

        }
    },
    watch: {
        'filters.summary_type': function (newValue, oldValue) {
            this.invoices = []
            this.unbilled = []
        }
    },
    mounted() {
        this.current_year = this.$moment().format('Y')
        for (let i = -7; i < 5; i++) {
            this.years.push(this.$moment().add(i, 'year').format('Y'))
        }
        this.period.end = moment().format('YYYY-MM-DD');
        this.period.start = moment().format('YYYY-MM-DD');
        //this.period.start = moment().subtract(24, 'days').format('YYYY-MM-DD');

    },
    methods: {
        cleanHTML(html) {
            if (!html) return '';
            // Remove all HTML tags and collapse whitespace
            return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        },
        truncateAddress(html, limit = 20) {
            if (!html) return '';
            const text = this.cleanHTML(html);
            return text.length > limit ? text.slice(0, limit) + '...' : text;
        },
        removeInvoice(invoice_id) {
            if (confirm(`Are you sure you want to delete invoice #${invoice_id}?`)) {
                let app = this;
                app.loading.invoice = true
                axios.post('/billings/delete-invoice', {
                    inv_id: invoice_id
                }).then((response) => {
                    for (let i = 0; i < app.invoices.length; i++) {
                        if (app.invoices[i].inv_id === invoice_id) {
                            app.invoices[i].inv_id = null;
                        }
                    }
                    app.$forceUpdate()
                }).finally(() => {
                    app.loading.invoice = false
                })
            }
        },
        createCreditMemo(invoice_id) {
            this.selecteds = []
            this.isSelected = false;
            this.siteId = ''
            window.open(`/billings/show-invoice/${invoice_id}?cm=1`, '_blank');
        },
        clearMonth() {
            this.month_components.forEach((e) => {
                let cc = this.$refs[e]
                cc.selectedMonth = ""
            })

            this.current_year = (new Date).getFullYear()
            this.filters = {
                summary_type: 2,
                summary_type_select: ''
            }

            this.$refs.billing_account.model_id = '';
            this.$refs.salesperson.model_id = '';

            this.invoices = []
            this.unbilled = []
            this.selecteds = []
            this.isSelected = false;
            this.siteId = ''
        },
        setMonth(val) {
            let app = this;
            this.month_components.forEach((e) => {
                let cc = this.$refs[e]
                if (cc._uid !== val._uid) {
                    cc.selectedMonth = ""
                } else {
                    let firstPart = e.split('_')[0];
                    let secondPart = e.split('_')[1];
                    switch (firstPart) {
                        case 'rsm':
                            app.sid = 67
                            break;
                        case 'em':
                            app.sid = 84
                            break;
                        case 'sr':
                            app.sid = -1
                            break;
                        case 'bc':
                            app.sid = -2
                            break;
                        default:
                            app.sid = 0

                    }

                    if (secondPart === 'ri') {
                        app.report_month = cc.$data.selectedMonth
                        app.bill_month = null
                        app.bill_other = null
                        app.type = 'report'
                    } else {
                        app.report_month = null
                        app.bill_month = cc.$data.selectedMonth
                        app.bill_other = null
                        app.type = 'bill'
                    }
                }
            })
        },

        submit_invoice_request(submit_type) {
            this.submitType = submit_type
            this.loading.invoice = true
            let app = this;
            app.summary = {
                projected: 0,
                completed: 0,
                billed: 0,
            }
            app.invoices = []
            this.selecteds = []
            this.isSelected = false;
            this.siteId = ''
            axios.get('/billings/summary', {
                headers: {},
                params: {
                    ...app.period,
                    sid: app.sid,
                    report_month: app.report_month,
                    bill_month: app.bill_month,
                    bill_other: app.bill_other,
                    submit_type: this.submitType,
                    type: app.type,
                    year: app.current_year,
                    ...this.filters,
                }
            }).then((response) => {
                app.summary = response.data.summary
                app.invoices = response.data.invoices
                app.unbilled = response.data.unbilled
            }).finally(() => {
                app.loading.invoice = false
            })

            app.loaded = true;
        },

        inv_bill(billingAccount, siteId, sifid) {
            this.loading.invoice = true
            let app = this;
            const rows = Array.from(document.querySelectorAll(`tr[data-bill-account="${billingAccount}"]`));
            const siteAccNumbers = rows.map(row => {
                const siteAccElement = row.querySelector('.service_ticket_number');
                return siteAccElement ? siteAccElement.textContent.trim() : null;
            }).filter(Boolean);
            const indexInvoices = rows.map(row => {
                const siteAccElement = row.querySelector('.indexInvoice');
                return siteAccElement ? siteAccElement.textContent.trim() : null;
            }).filter(Boolean);

            axios.post('/billings/generate-invoice', {
                'service_tickets': siteAccNumbers,
                sid: app.sid,
                report_month: app.report_month,
                bill_month: app.bill_month,
                bill_other: app.bill_other,
                type: app.type,
                year: app.current_year,
                sifid: sifid,
                sites: [siteId]
            }).then((response) => {
                let id = response.data.id
                indexInvoices.forEach((index) => {
                    app.invoices[index].inv_id = id;
                })
                app.$forceUpdate()
                app.openInvoice(id)
            }).finally(() => {
                app.loading.invoice = false
            })
        },
        inv_svc(ticketId, site_id, sifid, index) {
            this.loading.invoice = true
            let app = this;

            const rows = Array.from(document.querySelectorAll(`tr[data-ticket-id="${ticketId}"]`));
            const indexInvoices = rows.map(row => {
                const siteAccElement = row.querySelector('.indexInvoice');
                return siteAccElement ? siteAccElement.textContent.trim() : null;
            }).filter(Boolean);

            axios.post('/billings/generate-invoice', {
                'service_tickets': [ticketId],
                sid: app.sid,
                report_month: app.report_month,
                bill_month: app.bill_month,
                bill_other: app.bill_other,
                type: app.type,
                year: app.current_year,
                sifid: sifid,
                sites: [site_id]
            }).then((response) => {
                let id = response.data.id
                indexInvoices.forEach((indexHere) => {
                    app.invoices[indexHere].inv_id = id;
                })
                app.$forceUpdate()
                app.openInvoice(id)
            }).finally(() => {
                app.loading.invoice = false
            })
        },
        sel_bill(siteId, sifid) {
            this.isSelected = true;
            this.siteId = siteId;

        },
        assignInvoice(){

            if (!this.selecteds){
                showMessage('e', 'No records checked')
                return;
            }

             this.loading.invoice = true
             let app = this;
              const rows = Array.from(document.querySelectorAll(`tr[data-site-id="${this.siteId}"]`));
              const siteAccNumbers = rows.map(row => {
                  const siteAccElement = row.querySelector('.service_ticket_number');
                  return siteAccElement ? siteAccElement.textContent.trim() : null;
              }).filter(Boolean);
              const indexInvoices = rows.map(row => {
                  const siteAccElement = row.querySelector('.indexInvoice');
                  return siteAccElement ? siteAccElement.textContent.trim() : null;
              }).filter(Boolean);
                        axios.post('/billings/generate-invoice', {
                            'service_tickets': siteAccNumbers,
                            sid: app.sid,
                            report_month: app.report_month,
                            bill_month: app.bill_month,
                            bill_other: app.bill_other,
                            type: app.type,
                            year: app.current_year,
                            rows_ids: this.selecteds,
                            sifid: null,
                            sites: [this.siteId]
                        }).then((response) => {
                            let id = response.data.id
                            indexInvoices.forEach((index) => {
                                if (this.selecteds.includes(app.invoices[index].row_id)) {
                                    app.invoices[index].inv_id = id;
                                }
                            })
                            app.selecteds = []
                            app.isSelected = false;
                            app.siteId = ''
                            app.$forceUpdate()
                            app.openInvoice(id)

                        }).finally(() => {
                            app.loading.invoice = false
                        })
        },
        openInvoice(id) {
            this.selecteds = []
            this.isSelected = false;
            this.siteId = ''
            window.open(`/billings/show-invoice/${id}`, '_blank');
        },

        openModalPurchaseOrder(serviceTicket, siteId) {
            this.serviceTicket = serviceTicket;
            this.siteId = siteId
            let app = this;
            setTimeout(function () {
                app.$refs["customer-purchase-order"].getCustomerPurchaseOrders()
                app.modal.customer_purchase_order = true;
            }, 100)

        },

    }
}
</script>

<style scoped>
.ready_invoice {
    padding: 5px;
}

.factions span {
    font-size: 20px;
    margin-top: 5px;
}


.b-filter label {
    width: 120px;
}

.b-filter .col-md-12.d-flex {
    margin-bottom: 3px;
}

.table-invoice {
    border-collapse: separate;
    text-indent: initial;
    border-spacing: 5px;
}

.table-invoice td {
    background: #efefef;
    text-wrap: nowrap;
    vertical-align: top;
}

.table-invoice th {
    font-weight: normal;
    padding-bottom: 5px;
    text-align: center;
    border-bottom: 1px solid #333;
    vertical-align: bottom;
    color: #CC0000;
}

.table-invoice .invoice_td a {
    margin-left: 5px;
}

.table-invoice .invoice_td_id a {
    margin-left: 5px;
}


.table-invoice thead th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.table-invoice thead td {
    background-color: white;
    z-index: 1;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.signer_invoice {
    position: fixed;
    border: 1px solid rgb(0, 0, 0);
    padding: 3px;
    background: rgb(238, 238, 238);
    left: 8vw;
    top: 80vh;
    font-size: 14px;
}
</style>
